<template>
  <pt-goods-detail class="pt-goods-detail__withData" :goods-detail="goodsDetail" :id="id" :goodsUrl="goodsUrl" :loading="loading||urlLoading" :isPublished="isPublished"></pt-goods-detail>
</template>

<script>
import PtGoodsDetail from './index'
export default {
  name: 'pt-goods-detail__withData',
  components: {
    'pt-goods-detail': PtGoodsDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 商品是否已过上架
    isPublished () {
      return this.goodsDetail.goodsDTO && this.goodsDetail.goodsDTO.state && this.goodsDetail.goodsDTO.state === 'PUBLISHED'
    }
  },
  data () {
    return {
      goodsDetail: {},
      goodsUrl: '',
      loading: false,
      urlLoading: false
    }
  },
  methods: {
    bannerGoodsResources () {
      let data = {
        id: this.id,
        type: 'CAROUSEL'
      }
      this.urlLoading = true
      this.$store.dispatch('bannerGoodsResources', data).then(res => {
        this.goodsUrl = res.url
        this.urlLoading = false
      }).catch(err => {
        this.urlLoading = false
        this.$message.error(err || '获取活动信息失败')
      })
    },
    getGoodsDetail () {
      this.loading = true
      let data = {
        id: this.id
      }
      this.$store.dispatch('salesGoodsDetail', data).then(res => {
        this.loading = false
        this.goodsDetail = res
        if (this.isPublished) {
          this.bannerGoodsResources()
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取商品详情失败')
      })
    }
  },
  created () {
    this.getGoodsDetail()
  }
}
</script>
